var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNavbarIcBanking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D16",
    d: "M28.716 27.442H3.272a1.272 1.272 0 100 2.545h25.443a1.272 1.272 0 000-2.545zM4.864 24.134a1.272 1.272 0 100 2.545h22.262a1.273 1.273 0 000-2.545h-.318v-11.45h.318a.635.635 0 100-1.272H4.864a.635.635 0 100 1.272h.318v11.449h-.318zm19.4-11.45v11.449h-3.817v-11.45h3.817zm-6.362 0v11.449h-3.816v-11.45h3.816zm-10.177 0h3.817v11.449H7.725v-11.45zM3.273 10.268h25.454a1.272 1.272 0 00.413-2.476l-12.623-5.68a1.275 1.275 0 00-1.044 0L2.751 7.836a1.272 1.272 0 00.522 2.432z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavbarIcBanking);
export default __webpack_public_path__ + "static/media/icon_navbar_ic_banking.ca5dd5f2f737e48f67ceb0f3206f07c9.svg";
export { ForwardRef as ReactComponent };